<main>
    <section [style.background-color]="mServ.menu.couleurGauche | couleur" [style.background-image]="'url(' + (mServ.menu.medias[0].url) + ')'" class="img"></section>
    <section [style.background-color]="mServ.menu.couleurDroite | couleur" class="contenu">
        <h1>{{ mServ.menu['titre_'+mServ.langue] }}</h1>
        <i (click)="setFiltre()" class="fas fa-globe"></i>
        <article *ngFor="let a of mServ.pages[mServ.menu.chemin] | lang:filtre | reverse">
            <h2>{{ a.titre }}</h2>
            <blockquote *ngIf=" a.intro ">{{ a.intro }}</blockquote>
            <p class="cache">{{ a.contenu }}</p>
            <a [href]="a.lien" title="Aller sur le site Internet" target="_blank" *ngIf="a.lien" class="lien">{{ mServ.getTraduction('plus') }}</a>
            <button (click)="toolsServ.showArticle(a)" *ngIf="a.contenu">{{ mServ.getTraduction('suite') }}</button>
            <h3 *ngIf="a.fichiers && a.fichiers.length > 0">{{ mServ.getTraduction('fichiers') }}</h3>
            <ul *ngIf="a.fichiers && a.fichiers.length > 0">
                <li *ngFor="let f of a.fichiers">
                    <a *ngIf="f.fichiers.url" [href]="f.fichiers.url" target="_blank"><i class="fas fa-paperclip"></i> {{ f.titre }} ({{ f.fichiers.ext }})</a>
                    <a *ngIf="f.lien" [href]="f.lien" target="_blank"><i class="fas fa-paperclip"></i> {{ f.titre }}</a>
                </li>
            </ul>
        </article>
    </section>
</main>
<app-plus [infos]="toolsServ.article" *ngIf="toolsServ.article"></app-plus>